import { createPopper as c } from "@popperjs/core";
import { LitElement as d, unsafeCSS as h } from "lit";
import { property as i } from "lit/decorators.js";
import _ from "../../foundations/icon/icon.style.css.js";
import { booleanType as n } from "../../utils/property-types.js";
import f from "./tooltip.style.css.js";
import { template as m } from "./tooltip.template.js";
var v = Object.defineProperty, s = (a, e, t, p) => {
  for (var r = void 0, l = a.length - 1, u; l >= 0; l--)
    (u = a[l]) && (r = u(e, t, r) || r);
  return r && v(e, t, r), r;
};
class o extends d {
  constructor() {
    super(...arguments), this._parent = null, this._parentMouseEnterHandler = null, this._parentMouseLeaveHandler = null, this._parentFocusInHandler = null, this._parentFocusOutHandler = null, this._closeTimeoutId = null, this.observerConfig = { attributes: !0, childList: !0, subtree: !0 }, this.callback = (e) => {
      for (const t of e)
        if (t.type === "attributes" && t.attributeName === "data-popper-placement") {
          const p = this.getAttribute("data-popper-placement");
          p && this._propagatePlacement(p);
        }
    }, this.observer = new MutationObserver(this.callback), this.position = "top", this.align = "left", this.hide = !1, this.noHeightLimit = !1, this.tooltipFixed = !1, this.interactive = !1, this.forceViewport = !1, this._popperInstance = null;
  }
  static get styles() {
    return [h(_), h(f)];
  }
  connectedCallback() {
    super.connectedCallback(), this._parent = this.parentElement, this._parent && this.createPopperInstance(this._parent);
  }
  disconnectedCallback() {
    this.observer.disconnect(), this._clearCloseTimeout(), this._parent && (this._parentMouseEnterHandler && this._parent.removeEventListener("mouseenter", this._parentMouseEnterHandler), this._parentMouseLeaveHandler && this._parent.removeEventListener("mouseleave", this._parentMouseLeaveHandler), this._parentFocusInHandler && this._parent.removeEventListener("focusin", this._parentFocusInHandler), this._parentFocusOutHandler && this._parent.removeEventListener("focusout", this._parentFocusOutHandler), this._parentMouseEnterHandler = null, this._parentMouseLeaveHandler = null, this._parentFocusInHandler = null, this._parentFocusOutHandler = null, this._parent = null), this._popperInstance && (this._popperInstance.destroy(), this._popperInstance = null);
  }
  async firstUpdated() {
    try {
      await this.updateComplete, this.observer.observe(this, this.observerConfig);
    } catch {
      console.error("ERROR OCURRED");
    }
  }
  updated(e) {
    super.updated(e), e.has("position") && this._popperInstance && this._popperInstance.setOptions({
      placement: this.position
    });
  }
  _getPopperStrategy() {
    return this.tooltipFixed ? "fixed" : "absolute";
  }
  _getPopperModifiers() {
    const e = [
      {
        name: "offset",
        options: {
          offset: [0, 8]
        }
      }
    ];
    return this.forceViewport ? [
      ...e,
      {
        name: "preventOverflow",
        options: {
          boundary: "viewport",
          rootBoundary: "viewport",
          altBoundary: !0,
          padding: { top: 8, bottom: 8, left: 16, right: 16 }
        }
      },
      {
        name: "flip",
        options: {
          boundary: "viewport",
          rootBoundary: "viewport",
          altBoundary: !0
        }
      }
    ] : [
      ...e,
      {
        name: "preventOverflow",
        options: {
          padding: { top: 8, bottom: 8, left: 16, right: 16 }
        }
      }
    ];
  }
  createPopperInstance(e) {
    this._popperInstance = c(e, this, {
      placement: this.position,
      strategy: this._getPopperStrategy(),
      modifiers: this._getPopperModifiers(),
      onFirstUpdate: (t) => {
        this._propagatePlacement(t.placement);
      }
    }), this._parentMouseEnterHandler = () => {
      this._openTooltip();
    }, this._parentMouseLeaveHandler = () => {
      if (this.interactive) {
        this._scheduleClose();
        return;
      }
      this._closeTooltip();
    }, this._parentFocusInHandler = () => {
      this.classList.contains("visible") || this._openTooltip();
    }, this._parentFocusOutHandler = () => {
      this.classList.contains("visible") && this._closeTooltip();
    }, e.addEventListener("mouseenter", this._parentMouseEnterHandler), e.addEventListener("mouseleave", this._parentMouseLeaveHandler), e.addEventListener("focusin", this._parentFocusInHandler), e.addEventListener("focusout", this._parentFocusOutHandler);
  }
  _onMouseEnter(e) {
    if (!this.interactive) {
      e.stopPropagation(), e.preventDefault(), this._closeTooltip(), this.style.pointerEvents = "none";
      return;
    }
    this._clearCloseTimeout();
  }
  _onMouseLeave() {
    this.interactive && this._scheduleClose();
  }
  _openTooltip() {
    var e;
    this._clearCloseTimeout(), (e = this._popperInstance) == null || e.update(), this.classList.add("visible");
  }
  _closeTooltip() {
    this.classList.remove("visible");
  }
  _scheduleClose() {
    this._clearCloseTimeout(), this._closeTimeoutId = window.setTimeout(() => {
      this._closeTimeoutId = null, this._closeTooltip();
    }, 150);
  }
  _clearCloseTimeout() {
    this._closeTimeoutId !== null && (window.clearTimeout(this._closeTimeoutId), this._closeTimeoutId = null);
  }
  _propagatePlacement(e) {
    const t = this.renderRoot.querySelector(".dss-tooltip-box");
    t && t.setAttribute("data-popper-placement", e);
  }
  updateTooltip() {
    this._popperInstance.update();
  }
  render() {
    return m(this);
  }
}
s([
  i({ type: String })
], o.prototype, "position");
s([
  i({ type: String })
], o.prototype, "align");
s([
  i(n)
], o.prototype, "hide");
s([
  i(n)
], o.prototype, "noHeightLimit");
s([
  i(n)
], o.prototype, "tooltipFixed");
s([
  i(n)
], o.prototype, "interactive");
s([
  i(n)
], o.prototype, "forceViewport");
export {
  o as Tooltip
};
//# sourceMappingURL=tooltip.js.map
